// Shared option maps + helpers for the "Advanced Settings" hardware-table controls
// used by the public /update and /beta flashers.
//
// The hardware table is a small structured binary flashed at offset 0xfe9000:
//   byte 0 = PCB revision
//   byte 1 = PCB type   (0 = Fluora, 1 = Monos)
//   byte 2 = factory test performed (the public flashers always send 1)
//   byte 3 = model type (0 = Fluora Floor, 1 = Fluora Mini, 2 = Monos, 3 = Fluora Uno)

// Soft access code that gates the Advanced Settings content on the public
// /update and /beta flashers. This is not a security boundary (it lives in the
// client bundle) — it just prevents customers from stumbling into advanced
// partition flashing without contacting customer service. Change it here to
// update it in both flashers.
export const ADVANCED_ACCESS_CODE = 'rgb';

export const PCB_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: '0', label: 'Fluora' },
  { value: '1', label: 'Monos' },
];

export const MODEL_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: '0', label: 'Fluora Floor' },
  { value: '1', label: 'Fluora Mini' },
  { value: '2', label: 'Monos' },
  { value: '3', label: 'Fluora Uno' },
];

export interface HardwareTableDefaults {
  pcbType: string;
  modelType: string;
}

// Valid PCB revisions per PCB type. Fluora boards ship as rev 4 or 5; Monos
// boards are rev 3 only.
export const PCB_REVISION_OPTIONS_BY_TYPE: Record<string, string[]> = {
  '0': ['4', '5'], // Fluora
  '1': ['3'], // Monos
};

export function getPcbRevisionOptions(pcbType: string): string[] {
  return PCB_REVISION_OPTIONS_BY_TYPE[pcbType] ?? [];
}

// Derive sensible PCB type / model type defaults from the selected model name.
export function getHardwareTableDefaults(modelName: string): HardwareTableDefaults {
  switch (modelName) {
    case 'Monos':
      return { pcbType: '1', modelType: '2' };
    case 'Fluora Floor':
      return { pcbType: '0', modelType: '0' };
    case 'Fluora Mini':
      return { pcbType: '0', modelType: '1' };
    case 'Fluora Uno':
      return { pcbType: '0', modelType: '3' };
    default:
      return { pcbType: '0', modelType: '1' };
  }
}
